import React from 'react';
import PropTypes from 'prop-types';
import {Header} from 'semantic-ui-react';

import EmailPreviewAlertTable from '@modules/eventContentAlert/components/EmailPreviewAlertTable';

const EmailAlertPreviewModal = ({dataForPreview, submittedData, sanitizedContent}) => {
    return (
        <div className='AlertPreviewContent'>
            <Header content={'Title'}/>
            <div className={'--title'}>{dataForPreview.subject}</div>
            <div className='emailPreviewBody'>
                <Header content={'Body'}/>
                {/*eslint-disable-next-line react/no-danger */}
                <div dangerouslySetInnerHTML={{__html: sanitizedContent}}/>
            </div>
            <div className='emailPreviewRecipients'>
                <Header content={'Recipients'}/>
                <EmailPreviewAlertTable data={dataForPreview.recipients}/>
                {0 < submittedData.additional_recipients?.length && (
                    <div className='additionalRecipients'>
                        <strong>Additional recipients: </strong>
                        {submittedData.additional_recipients.join(', ')}
                    </div>
                )}
            </div>
        </div>
    );
};

EmailAlertPreviewModal.propTypes = {
    dataForPreview: PropTypes.object,
    submittedData: PropTypes.object,
    sanitizedContent: PropTypes.string,
};

export default EmailAlertPreviewModal;
